export interface Education {
  id: string;
  institution: string;
  degree: string;
  field: string;
  period: string;
  description: string;
  achievements: string[];
  thesisTitle?: string;
  thesisScore?: string;
  thesisRank?: string;
  videoUrl?: string;
}

export interface EducationData {
  education: Education[];
}

export const educationData: EducationData = {
  education: [
    {
      id: "academy-cryptography",
      institution: "Vietnam Academy of Cryptography Techniques",
      degree: "Information Technology (Embedded and mobile software major)",
      field: "",
      period: "2016 - 2021",
      description:
        "Graduated with a degree in Information Technology, majoring in Embedded and Mobile Software. GPA: 3.1.",
      achievements: ["Scientific research at school level"],
      thesisTitle:
        "Application system to manage and remind class schedules and academy credits.",
    },
  ],
};
